import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicEvent } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const getEvent = async (eventId: string) => {
  const response = await axiosClient.get(`/events/${eventId}`);
  return response.data;
};

export const getEventQueryKey = (eventId: string) => [
  "events",
  "event",
  eventId,
];
export function useGetEvent(
  eventId: string,
  queryOptions?: UseQueryOptions<PublicEvent, HttpError, PublicEvent>,
) {
  return useQuery<PublicEvent, HttpError, PublicEvent>({
    queryKey: getEventQueryKey(eventId),
    queryFn: () => getEvent(eventId),
    enabled: !!eventId,
    ...queryOptions,
  });
}
